import React, { useCallback, useEffect, useState } from 'react'
import { Template } from '../../Components/Template/template'
import { Link, useNavigate } from 'react-router-dom'
import {
    AlertType, DadosBorderoDup, Fornecedor, FornecedorAttributes, FornecedorSearchBox, classBorderLabelDark, classBt, classBtSemDuration, classDivBackground, classDivBody, classDivTitulo, classInput, classInputDark,
    classLabel, classLabelDark, classWeigthBt, classbtAzul, classbtCinzaClaro, classbtColunasAzul, classbtColunasVermelho, classbtVerde, classbtVermelho, contaAPagar
} from '../../Utils/Types'
import { IoSearch, IoAddCircleSharp } from 'react-icons/io5'
import { ContaAPagarService } from './ContaAPagarService'
import { GridContaAPagar } from '../../Components/GridProducts/GridContaAPagar'
import { SearchBox } from '../../Components/SearchBox/SearchBox'
import { FaTrash, FaVideo } from 'react-icons/fa'
import { Funcoes } from '../../Utils/Funcoes'
import { ModalLiqDup } from '../../Components/Modal/modal-liq-dup'
import moment from 'moment'
import { FeedbackMessage } from '../../Components/FeedbackMessage/feedback-message'
import { ModalEstornaDup } from '../../Components/Modal/modal-estorna-dup'
import { Tooltip } from 'react-tooltip'
import { HiDocumentDuplicate } from 'react-icons/hi'
import { AiOutlineClear } from 'react-icons/ai'
import { RelContaPagarGeralPDF } from './pdf/rel-contaPagarGeral'
import { FornecedorService } from '../Fornecedor/FornecedorService'
import { ModalTutorial } from '../../Components/Modal/modal-tutorial'
import { GridContaAPagarEstorno } from '../../Components/GridProducts/GridContaAPagarEstorno'

export const ContaAPagarPage = () => {

    let dateI = moment()
        .utcOffset('-03:00')
        .format('YYYY-MM-DD')

    let dateF = moment()
        .utcOffset('-03:00')
        .add(31, 'days')
        .format('YYYY-MM-DD')

    // ---------- ATRIBUTOS FEEDBACK -----------------
    const [loading, setLoading] = useState(false)
    const [visible, setVisible] = useState<boolean>(false)
    const [message, setMessage] = useState("")
    const [messageType, setMessageType] = useState<AlertType>("DANGER")

    // ------------- ATRIBUTOS FILTRO ----------------
    const [datai, setDatai] = useState(dateI)
    const [dataf, setDataf] = useState(dateF)
    const [numDoc, setNumDoc] = useState("")

    const [fornecedor, setFornecedor] = useState<FornecedorSearchBox[]>([])
    const [fornecedorList, setFornecedorList] = useState<FornecedorSearchBox[]>([])
    const [idFornecedor, setIdFornecedor] = useState(0)

    const [status, setStatus] = useState<string>("A")

    const [bordero, setBordero] = useState("")

    // ---------- ATRIBUTOS GRID ---------------------
    const [ctaPagarList, setCtaPagarList] = useState<contaAPagar[]>([])
    const [ctaPagarEstornoList, setCtaPagarEstornoList] = useState<DadosBorderoDup[]>([])

    // ------------- DADOS DUPLICATA -----------------
    const [qtdDup, setQtdDup] = useState(0)
    const [totDup, setTotDup] = useState(0)
    const [qtdDupSelecionado, setQtdDupSelecionado] = useState(0)
    const [totSelecionado, setTotSelecionado] = useState(0)
    const [dupSelectedList, setDupSelectedList] = useState<number[]>([])
    const [borderoSelectedList, setBorderoSelectedList] = useState<number[]>([])
    const [selectDupAll, setSelectDupAll] = useState(false)

    // ------------- MODAL ---------------------------
    const [modalLiqDupVisible, setModalLiqDupVisible] = useState(false)
    const [modalCancelLiqVisible, setModalCancelLiqVisible] = useState(false)

    // ------------- SEARCH BOX ----------------------
    const [visibleSearchBoxFornecedor, setVisibleSearchBoxFornecedor] = useState<boolean>(false)

    // ---------- ATRIBUTOS TUTORIAL --------------------------------------------------
    const [modalTutorialVisible, setModalTutorialVisible] = useState(false)

    //------------------------------------------------------------- REQUISIÇÃO API, ATALHOS E FOCUS ----------------------------------------------------------------------------//
    const getAttributes = async () => {
        setLoading(true)

        try {

            const resp = await FornecedorService.GetListFornecedor()
            setFornecedor(resp.data)
            setFornecedorList(resp.data)

        } catch (error) {

            setVisible(true)
            setMessageType("DANGER")
            setMessage(`Não foi possível buscar os fornecedores`)

        } finally {

            const timer = setTimeout(() => {
                setLoading(false)
                clearTimeout(timer)
            }, 0)
        }
    }

    const handleMouseUp = useCallback((e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        // Desfocar o link após o clique
        const target = e.target as HTMLElement
        if (target instanceof HTMLAnchorElement) {
            target.blur()
        }

        inputFocus()
    }, [])

    const handleKeyPressEnter = async (e: any) => {

        let menuFiltro = document.getElementById("divMenuFiltroDup") as HTMLDivElement

        if ((e.code === "Enter" || e.code === "NumpadEnter") && !modalLiqDupVisible && !modalCancelLiqVisible && !visibleSearchBoxFornecedor && !loading && menuFiltro.classList.contains("max-h-[1000px]")) {
            await handleFilterClick()
        }
    }

    const handleTabPress = (event: any) => {

        if (event.key === 'Tab') {
            event.preventDefault() // Evita o comportamento padrão do 'Tab'
        }
    }

    useEffect(() => {
        document.addEventListener('keydown', handleKeyPressEnter)
        document.addEventListener('keydown', handleTabPress)

        return () => {
            document.removeEventListener('keydown', handleKeyPressEnter)
            document.removeEventListener('keydown', handleTabPress)
        }

    }, [datai, dataf, numDoc, idFornecedor, status, bordero, modalCancelLiqVisible, modalLiqDupVisible, visibleSearchBoxFornecedor, loading])

    useEffect(() => {
        getAttributes()
    }, [])

    useEffect(() => {
        setCtaPagarList([])
        setCtaPagarEstornoList([])
        setBorderoSelectedList([])
        setSelectDupAll(false)
        setQtdDup(0)
        setTotDup(0)
        setQtdDupSelecionado(0)
        setTotSelecionado(0)
        setBordero("")
    }, [status])

    const inputFocus = () => {
        const inputElement = document.getElementById("dt_ini__dup_pagar")
        inputElement?.focus()
    }

    const inputDesfocus = () => {
        const inputElement = document.getElementById("dt_ini__dup_pagar")
        inputElement?.blur()
    }

    const searchBoxFocus = () => {
        setVisibleSearchBoxFornecedor(false)
    }

    const handleCloseMessage = () => {
        setVisible(false)
    }

    //--------------------------------------------------------------------------------------------- FILTROS ------------------------------------------------------------------------------------------//
    const handleFilterClick = async () => {

        setVisible(false)
        setLoading(true)

        setCtaPagarList([])
        setCtaPagarEstornoList([])
        setBorderoSelectedList([])
        setSelectDupAll(false)
        setQtdDup(0)
        setTotDup(0)
        setQtdDupSelecionado(0)
        setTotSelecionado(0)

        searchBoxFocus()
        inputDesfocus()

        try {

            if (status === 'A') {

                const relatorio = {
                    datai: datai,
                    dataf: dataf,
                    id_fornecedor: idFornecedor.toString(),
                    tipo: status,
                    num_doc: numDoc
                }

                const dados = await ContaAPagarService.Filter(relatorio)

                if (dados.error) {

                    setVisible(true)
                    setMessageType("DANGER")
                    setMessage(dados.msg || "")

                } else {

                    setCtaPagarList(dados.data.ctaPagar)
                    setQtdDup(dados.data.qtdDup)
                    setTotDup(dados.data.total)

                }

            } else {

                const relatorio = {
                    datai: datai,
                    dataf: dataf,
                    id_fornecedor: idFornecedor,
                    tipo: status,
                    num_doc: numDoc,
                    bordero: bordero
                }

                const dados = await ContaAPagarService.FilterBordero(relatorio)

                if (dados.error) {

                    setVisible(true)
                    setMessageType("DANGER")
                    setMessage(dados.msg || "")

                } else {

                    //console.log("dados: ", dados)

                    setCtaPagarEstornoList(dados.data.ctaPagar)
                    setQtdDup(dados.data.qtd)
                    setTotDup(dados.data.total)

                }

            }


        } catch (error) {

            setVisible(true)
            setMessageType("DANGER")
            setMessage(`Não foi possível buscar as duplicatas`)

        } finally {
            setSelectDupAll(false)
            const timer = setTimeout(() => {
                inputFocus()
                setLoading(false)
                clearTimeout(timer)
            }, 1500)
        }

        /*
        const relatorio = {
            datai: datai,
            dataf: dataf,
            id_fornecedor: idFornecedor.toString(),
            tipo: status,
            num_doc: numDoc
        }

        setRelatorios(relatorio)
        */
    }

    const filterDados = useCallback(async () => {

        setVisible(false)

        setCtaPagarList([])
        setCtaPagarEstornoList([])
        setBorderoSelectedList([])
        setSelectDupAll(false)
        setQtdDup(0)
        setTotDup(0)
        setQtdDupSelecionado(0)
        setTotSelecionado(0)

        try {

            if (status === 'A') {

                const relatorio = {
                    datai: datai,
                    dataf: dataf,
                    id_fornecedor: idFornecedor.toString(),
                    tipo: status,
                    num_doc: numDoc
                }

                const dados = await ContaAPagarService.Filter(relatorio)

                if (dados.error) {

                    setVisible(true)
                    setMessageType("DANGER")
                    setMessage(dados.msg || "")
                    return false

                } else {

                    setCtaPagarList(dados.data.ctaPagar)
                    setQtdDup(dados.data.qtdDup)
                    setTotDup(dados.data.total)
                    return true
                }

            } else {

                const relatorio = {
                    datai: datai,
                    dataf: dataf,
                    id_fornecedor: idFornecedor,
                    tipo: status,
                    num_doc: numDoc,
                    bordero: bordero
                }

                const dados = await ContaAPagarService.FilterBordero(relatorio)

                if (dados.error) {

                    setVisible(true)
                    setMessageType("DANGER")
                    setMessage(dados.msg || "")
                    return false

                } else {

                    setCtaPagarEstornoList(dados.data.ctaPagar)
                    setQtdDup(dados.data.qtdDup)
                    setTotDup(dados.data.total)
                    return true
                }

            }

        } catch (error) {

            setVisible(true)
            setMessageType("DANGER")
            setMessage(`Não foi possível buscar as duplicatas`)
            return false

        }

    }, [ctaPagarList, ctaPagarEstornoList, status, datai, dataf, idFornecedor, numDoc, bordero])

    const toggleMenuFiltro = (event: any) => {

        let menuFiltro = document.getElementById("divMenuFiltroDup") as HTMLDivElement

        let menuInputs = document.getElementById("divInputsDup") as HTMLDivElement

        searchBoxFocus()

        if (menuFiltro) {

            menuFiltro.classList.toggle("max-h-[1000px]")
            menuFiltro.classList.toggle("max-h-[0px]")

            if (menuFiltro.classList.contains("max-h-[1000px]")) {

                //setSearchBoxResponsivo(true)

                menuInputs.classList.remove("invisible")

                const timer = setTimeout(() => {
                    inputFocus()
                    clearTimeout(timer)
                }, 150)

            } else {

                //setSearchBoxResponsivo(false)

                menuInputs.classList.add("invisible")

            }

            event.currentTarget.blur()
        }


    }

    const handleLimparFiltros = () => {

        setDatai(dateI)
        setDataf(dateF)
        setNumDoc("")
        setIdFornecedor(0)
        setStatus("A")

        setBordero("")

        setVisible(false)
        searchBoxFocus()
        inputFocus()
    }

    const handleChangeDtInicio = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDatai(e.target.value)
    }

    const handleChangeDtFim = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDataf(e.target.value)
    }

    const handleChangeNumDoc = (e: React.ChangeEvent<HTMLInputElement>) => {
        setNumDoc(e.target.value)
    }

    const handleChangeStatus = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setStatus(e.target.value)
    }

    const handleChangeBordero = (e: React.ChangeEvent<HTMLInputElement>) => {
        setBordero(e.target.value.replace(/[^0-9]/g, ''))
    }

    //-------------------------------------------------------------------- PDF ---------------------------------------------------------------------------------------//
    /* // caso seja necessario ter o botao de imprimir aqui voltar com esse codigo
    const handleGerarPDFClick = async (event: any) => {
        

        try {

            const pdf = new RelContaPagarGeralPDF(ctaPagarList, totalDuplicatas, totalValor)
            pdf.GerarPDF(ctaPagarList)

            event.currentTarget.blur()

        } catch (error) {

            setVisible(true)
            setMessageType('DANGER')
            setMessage(`Ocorreu um erro ao imprimir. Por favor, tente novamente`)
        }

    }
    */

    //--------------------------------------------------------------------------------------------- FORNECEDOR ------------------------------------------------------------------------------------------//
    const handleClearFornecedorSelecionada = useCallback(() => {
        const newFornList = [...fornecedor || []]
        setFornecedorList(newFornList)
        setIdFornecedor(0)

        setVisibleSearchBoxFornecedor(false)
    }, [fornecedor])

    const handleFilterFornecedorClick = useCallback(async (description: string) => {

        if (description === "") {
            const newFornList = [...fornecedor || []]
            setFornecedorList(newFornList || [])

        } else {
            const newFornList = [...fornecedor || []].filter((item) => {
                return item.description.toLocaleLowerCase().startsWith(description.toLocaleLowerCase())
            })
            setFornecedorList(newFornList || [])
        }

    }, [fornecedor])

    const handleFornecedorSelectClick = useCallback((v: FornecedorSearchBox) => {

        if (v) {
            const newFornList = [...fornecedor || []]
            setFornecedorList(newFornList)
            setIdFornecedor(v.id)
        }

        setVisibleSearchBoxFornecedor(false)

    }, [fornecedor])

    const clickSearchBoxFornecedor = useCallback(() => {
        setVisibleSearchBoxFornecedor((prevState) => {
            const newState = !prevState // Alterna o estado atual
            if (newState) {
                inputFocusFornecedor()
            }
            return newState
        })
    }, [])

    const inputFocusFornecedor = () => {
        let inputSearch = document.getElementById(`inputSearchBox-fornecedor`) as HTMLInputElement

        const timer = setTimeout(() => {
            inputSearch?.focus()
            clearTimeout(timer)
        }, 10)
    }

    //--------------------------------------------------------------------------------------------- FUNÇÕES GRID ------------------------------------------------------------------------------------------//
    const handleColumnLiqClick = useCallback(() => {

        let newCtaPagarList = [...ctaPagarList]
        newCtaPagarList = [...ctaPagarList]
        let total = 0

        for (let i in newCtaPagarList) {
            newCtaPagarList[i].selected = !selectDupAll
            total += newCtaPagarList[i].valor
        }

        if (selectDupAll) {
            setTotSelecionado(0)
        } else {
            setTotSelecionado(total)
        }

        setCtaPagarList(newCtaPagarList)
        setSelectDupAll(!selectDupAll)
    }, [ctaPagarList, selectDupAll])

    const handleCheckBoxClick = useCallback((id: number, selected: boolean) => {
        const newCtaPagarList = [...ctaPagarList]
        const index = newCtaPagarList.findIndex((item) => item.id === id)

        if (index >= 0) {
            // Atualiza o estado do item selecionado
            newCtaPagarList[index].selected = !selected // Alterna entre true e false
            const itemSelecionado = newCtaPagarList[index]

            // Atualiza a lista de ctaPagarList com a alteração
            setCtaPagarList(newCtaPagarList)

            setTotSelecionado((prevTotal) => {
                let newTotal = prevTotal

                if (!selected) {
                    newTotal += itemSelecionado.valor // Se foi desmarcado, subtrai
                } else {
                    newTotal -= itemSelecionado.valor // Se foi marcado, adiciona
                }

                return parseFloat(newTotal.toFixed(2))
            })
        }
    }, [ctaPagarList])

    const handleCheckBoxEstornoClick = useCallback((id: number, selected: boolean) => {
        const newCtaPagarEstornoList = [...ctaPagarEstornoList]
        const index = newCtaPagarEstornoList.findIndex((item) => item.id_bordero === id)

        if (index >= 0) {
            // Atualiza o estado do item selecionado
            newCtaPagarEstornoList[index].selected = !selected // Alterna entre true e false
            const itemSelecionado = newCtaPagarEstornoList[index]

            // Atualiza a lista de ctaPagarList com a alteração
            setCtaPagarEstornoList(newCtaPagarEstornoList)

            setTotSelecionado((prevTotal) => {
                let newTotal = prevTotal

                if (!selected) {
                    newTotal += itemSelecionado.valor // Se foi desmarcado, subtrai
                } else {
                    newTotal -= itemSelecionado.valor // Se foi marcado, adiciona
                }

                return parseFloat(newTotal.toFixed(2))
            })

            setQtdDupSelecionado((prevTotal) => {
                let newTotal = prevTotal

                if (!selected) {
                    newTotal += itemSelecionado.qtd // Se foi desmarcado, subtrai
                } else {
                    newTotal -= itemSelecionado.qtd // Se foi marcado, adiciona
                }

                return newTotal
            })
        }
    }, [ctaPagarEstornoList])

    const handlerOpenModalLiqDup = () => {

        setVisible(false)
        searchBoxFocus()

        let newCtaPagarList = [...ctaPagarList]
        newCtaPagarList = newCtaPagarList.filter((item) => item.selected === true)
        const newCtaSelectedList: number[] = []

        if (newCtaPagarList.length === 0) {

            const timer = setTimeout(() => {
                setMessage(`Nenhuma duplicata selecionada`)
                setMessageType("DANGER")
                setVisible(true)
                clearTimeout(timer)
            }, 0)
            return
        }

        newCtaPagarList.map((item) => newCtaSelectedList.push(item.id))
        setDupSelectedList(newCtaSelectedList)
        setModalLiqDupVisible(true)
    }

    const handlerOpenModalEstornarLiq = async () => {

        setVisible(false)
        searchBoxFocus()

        let newCtaPagarEstornoList = [...ctaPagarEstornoList]

        newCtaPagarEstornoList = newCtaPagarEstornoList.filter((item: DadosBorderoDup) => item.selected === true)
        const newDupPagarList: number[] = []
        const newBorderoList: number[] = []

        newCtaPagarEstornoList.map((item) => newDupPagarList.push(item.id_bordero))
        newCtaPagarEstornoList.map((item) => newBorderoList.push(item.id_bordero))

        setDupSelectedList(newDupPagarList)
        setBorderoSelectedList(newBorderoList)
        setModalCancelLiqVisible(true)
    }

    const fecharModalLiqDup = useCallback(() => {
        setModalLiqDupVisible(false)
    }, [])

    const fecharModalEstornaDup = useCallback(() => {
        setModalCancelLiqVisible(false)
    }, [])

    // ----------------------------------------------------------- SEM USO ------------------------------------------------------------
    /*const handlePrint = async () => {
        const device  = new escpos.Network('192.168.1.76')
        const printer = new escpos.Printer("")
        device.open(function(){
            printer
            .font('a')
            .align('ct')
            .style('bu')
            .size(1, 1)
            .text('The quick brown fox jumps over the lazy dog')
            .text('敏捷的棕色狐狸跳过懒狗')
            .barcode('1234567', 'EAN8')
            .table(["One", "Two", "Three"])
            .tableCustom(
              [
                { text:"Left", align:"LEFT", width:0.33, style: 'B' },
                { text:"Center", align:"CENTER", width:0.33},
                { text:"Right", align:"RIGHT", width:0.33 }
              ],
              { encoding: 'cp857', size: [1, 1] } // Optional
            )
            .qrimage('https://github.com/song940/node-escpos', function(){
                 
            })
          })
    }*/

    return (

        <Template isLoading={loading}>

            <div className={`${classDivBackground}`}>

                <div role='button' id="div-body" className={`${classDivBody}`}>

                    <FeedbackMessage visible={visible} message={message} type={messageType} onCloseMessage={handleCloseMessage} />

                    <div className={`${classDivTitulo} grid grid-cols-12 gap-4 p-2`}>

                        <div className={`relative col-span-12 sm:col-span-10 xl:col-span-6 flex flex-col sm:flex-row items-center space-y-2 sm:space-y-0`}>

                            <div className="flex flex-row">

                                <HiDocumentDuplicate className={`mx-2 text-slate-700 dark:text-slate-200`} size="25px" />
                                <span className={`text-base md:text-lg xl:text-2xl text-slate-700 dark:text-slate-200`}>Duplicatas a Pagar</span>

                            </div>

                            <button onClick={() => { setModalTutorialVisible(true) }} tabIndex={-1} disabled={loading} className={`${classBt} ${classbtAzul} ${classWeigthBt} h-9 shadow-md shadow-blue-600 mx-2`}  >
                                <FaVideo />
                                <span className='mx-1'>Tutorial</span>
                            </button>
                        </div>

                        <div className={`relative col-span-6 sm:col-span-2 xl:col-span-1`}>

                            <Link tabIndex={-1} onMouseUp={handleMouseUp} to={'/contaApagar/excluidos'} data-tooltip-id={'tooltip-btn-lixeira'} id={'btn-lixeira'} className={`${classbtColunasVermelho} h-9`} >
                                <FaTrash className={`mx-2`} size="25px" />
                            </Link>

                            <Tooltip style={{ backgroundColor: 'rgb(239, 68, 68)' }} id={'tooltip-btn-lixeira'} anchorSelect={'#btn-lixeira'} positionStrategy="fixed" place='left' >
                                <span>Duplicatas Excluídas</span>
                            </Tooltip>
                        </div>

                        <div className={`relative col-span-6 sm:col-span-4 xl:col-span-1`}>
                            <button tabIndex={-1} className={`${classbtColunasAzul} h-9`} onClick={toggleMenuFiltro} >
                                <span className={`w-full h-full flex justify-center items-center`}>Filtros</span>
                            </button>
                        </div>

                        {/*
                        <div className={`relative col-span-6 sm:col-span-3 2xl:col-span-1`}>
                            <button tabIndex={-1} className={`${classBtSemDuration} ${classbtCeuAzul} h-9 disabled:opacity-50 disabled:cursor-not-allowed`} disabled={!(ctaPagarList.length > 0) || !(status === 'A')} onClick={handleGerarPDFClick}>
                                <IoPrint size="25px" className={`mr-2 hidden md:block`} /> Imprimir
                            </button>
                        </div>
                        
                        */}

                        <div className={`relative col-span-6 sm:col-span-4 xl:col-span-2`}>
                            {status === "A" &&
                                <button tabIndex={-1} disabled={loading || totSelecionado === 0} className={`${loading || totSelecionado === 0 ? `opacity-40` : ``} ${classBt} ${classbtAzul} disabled:cursor-not-allowed w-full h-9`} onClick={handlerOpenModalLiqDup}>
                                    {/*
                                    <span className={`w-full h-full flex justify-center items-center`}>
                                        <FaDownload className='hidden mr-2 md:block' /> <span className='mx-1'>Liquidar duplicatas</span>
                                    </span>
                                    */}
                                    <span className='mx-1'>Liquidar duplicatas</span>
                                </button>
                            }

                            {status === "L" &&
                                <button tabIndex={-1} disabled={loading || totSelecionado === 0} className={`${loading || totSelecionado === 0 ? `opacity-40` : ``} ${classBt} ${classbtVermelho} disabled:cursor-not-allowed w-full h-9`} onClick={handlerOpenModalEstornarLiq}>
                                    {/*
                                    <span className={`w-full h-full flex justify-center items-center`}>
                                        <img src={estornoClaro} alt="Estorno" className="items-center justify-center hidden w-6 h-6 mx-1 md:block" /><span className='mx-1'>Estornar Duplicatas</span>
                                    </span>    
                                    */}
                                    <span className='mx-1'>Estornar duplicatas</span>
                                </button>
                            }
                        </div>

                        <div className={`relative col-span-6 sm:col-span-4 xl:col-span-2`}>

                            <Link tabIndex={-1} onMouseUp={handleMouseUp} to={'/contaApagar/new'} className={`${classBtSemDuration} ${classbtVerde} h-9`} >
                                <IoAddCircleSharp className={`mx-2 hidden md:block`} size="20px" /> Cadastro
                            </Link>

                            {/*
                            <button tabIndex={-1} onClick={navegarTelaContaAPagar} className={`${classBtSemDuration} ${classbtVerde} h-9`}>
                                <IoAddCircleSharp size="20px" className={`mr-2 hidden md:block`} /> Cadastro
                            </button>
                            */}


                        </div>

                    </div>

                    <div id='divInputsDup' className={`relative invisible ease-in-out duration-[150ms]`}>

                        <div id='divMenuFiltroDup' className={`relative max-h-[0px] h-[660px] sm:h-[390px] md:h-[340px] xl:h-[280px] 2xl:h-[210px] cursor-default bg-white dark:bg-slate-600 shadow-sm shadow-slate-400 dark:shadow-slate-800 border dark:border-slate-800 rounded-md overflow-y-hidden`} style={{ transitionDuration: "0ms, 300ms", transitionProperty: "background-color, max-height" }} />

                        <div className={`absolute top-0 w-full h-auto grid grid-cols-12 gap-3 py-4 px-3`}>

                            <div className={`relative col-span-12 sm:col-span-4 2xl:col-span-2 mt-2`}>
                                <input id="dt_inicial_dupPagar" className={`${classInput} ${classInputDark} ${datai === "" ? `text-blue-500 dark:text-cyan-300` : ``} dark:[color-scheme:dark]`} type='date' min="1900-01-01" max="9999-12-31" placeholder=' ' value={datai} onFocus={searchBoxFocus} onChange={handleChangeDtInicio} />
                                <label htmlFor="dt_inicial_dupPagar" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>{status === 'A' ? 'Data de Vencimento Inicial' : 'Data de Liquidação Inicial'}</label>
                            </div>

                            <div className={`relative col-span-12 sm:col-span-4 2xl:col-span-2 mt-2`}>
                                <input id="dt_final_dupPagar" className={`${classInput} ${classInputDark} ${dataf === "" ? `text-blue-500 dark:text-cyan-300` : ``} dark:[color-scheme:dark] `} type='date' min="1900-01-01" max="9999-12-31" placeholder=' ' value={dataf} onFocus={searchBoxFocus} onChange={handleChangeDtFim} />
                                <label htmlFor="dt_final_dupPagar" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>{status === 'A' ? 'Data de Vencimento Final' : 'Data de Liquidação Final'}</label>
                            </div>

                            <div className={`relative col-span-12 sm:col-span-4 2xl:col-span-2 mt-2`}>
                                <input id="num_doc_dupPagar" className={`${classInput} ${classInputDark}`} type='text' inputMode='text' maxLength={40} placeholder=' ' autoComplete='off' value={numDoc} disabled={loading} onFocus={searchBoxFocus} onChange={handleChangeNumDoc} />
                                <label htmlFor="num_doc_dupPagar" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Num. Documento</label>
                            </div>

                            <div className={`relative col-span-12 sm:col-span-8 xl:col-span-6 2xl:col-span-3 mt-2`}>
                                <SearchBox
                                    dataList={fornecedorList}
                                    idRegistro={idFornecedor || undefined}
                                    label='Fornecedor'
                                    componentId='fornecedor'
                                    visibleTAB={visibleSearchBoxFornecedor}
                                    setDataClick={handleFornecedorSelectClick}
                                    clearDataClick={handleClearFornecedorSelecionada}
                                    filterDataClick={handleFilterFornecedorClick}
                                    clicado={clickSearchBoxFornecedor}
                                />

                            </div>

                            <div className={`relative col-span-12 sm:col-span-4 xl:col-span-2 2xl:col-span-1 mt-2`}>
                                <select id="status_dupPagar" className={`${classInput} ${classInputDark} `} value={status} onFocus={searchBoxFocus} onChange={handleChangeStatus}>
                                    <option value="A" className={`text-slate-900 dark:text-slate-200`}>Abertas</option>
                                    <option value="L" className={`text-slate-900 dark:text-slate-200`}>Liquidadas</option>
                                </select>
                                <label htmlFor="status_dupPagar" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Status</label>
                            </div>

                            <div className={`relative col-span-12 sm:col-span-4 xl:col-span-2 mt-2`}>
                                <input id="bordero_dupPagar" className={`${classInput} ${classInputDark} `} type='text' inputMode="numeric" placeholder=' ' autoComplete='off' value={bordero} disabled={loading || status === "A"} onFocus={searchBoxFocus} onChange={handleChangeBordero} />
                                <label htmlFor="bordero_dupPagar" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Borderô</label>
                            </div>

                            <div className={`col-span-12 flex flex-col sm:flex-row justify-end sm:space-x-2 mt-3`}>

                                <div className={`relative mt-2 sm:mt-0`}>
                                    <button className={`${classBtSemDuration} ${classbtCinzaClaro} w-full sm:min-w-[150px]`} onClick={handleLimparFiltros}>
                                        <AiOutlineClear size="20px" className={`mr-[2px]`} /><span className='mx-1'>Limpar Campos</span>
                                    </button>
                                </div>

                                <div className={`relative mt-6 sm:mt-0`}>
                                    <button tabIndex={-1} disabled={loading} className={`${loading ? `opacity-40` : ``} ${classbtColunasAzul} w-full sm:min-w-[150px]`} onClick={handleFilterClick} >
                                        <span className={`w-full h-full flex justify-center items-center`}>
                                            {!loading && <IoSearch size="20px" className={`mr-2`} />}
                                            {loading &&
                                                <div className={`h-[20px] w-[20px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-[#2980b9] dark:text-slate-200 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                                    <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                                                </div>
                                            }
                                            {!loading && `Pesquisar`} {loading && `Aguarde`}
                                        </span>
                                    </button>
                                </div>

                            </div>

                            <div className={`col-span-12`}>

                                <div className={`flex flex-col md:flex-row md:py-2 justify-start w-full h-auto border border-slate-500 rounded-md bg-gray-200 dark:bg-slate-700`}>

                                    <div className={`w-full md:w-[25%] font-mono py-1 px-2 dark:text-slate-200 flex flex-row border md:border-none border-x-0 border-t-0 dark:border-slate-500 border-slate-400`}>
                                        <span className={`w-full md:w-auto`}>N° Duplicatas: </span>
                                        <span id='qtdDup' className={`w-full md:w-auto flex justify-end items-center md:ml-2`}>{qtdDup}</span>
                                    </div>

                                    <div className={`w-full md:w-[35%] font-mono py-1 px-2 dark:text-slate-200 flex flex-row border md:border-none border-x-0 border-t-0 dark:border-slate-500 border-slate-400`}>
                                        <span className={`w-full md:w-auto`}>Total: </span>
                                        <span id='totDup' className={`w-full md:w-auto flex justify-end items-center md:ml-2`}>{Funcoes.numberFormat(totDup, 'currency')}</span>
                                    </div>

                                    <div className={`w-full md:w-[40%] font-mono py-1 px-2 dark:text-slate-200 flex flex-row`}>
                                        <span className={`w-full md:w-auto`}>Total Selecionado: </span>
                                        <span id='totSelecionado' className={`w-full md:w-auto flex justify-end items-center md:ml-2`}>{Funcoes.numberFormat(totSelecionado, 'currency')}</span>
                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>

                    <div className={`w-full cursor-default mt-1 z-0 border shadow-sm shadow-slate-400 dark:bg-slate-600 dark:border-slate-800 dark:shadow-slate-800`}>

                        {status === 'A' &&

                            <GridContaAPagar
                                duplicata={ctaPagarList}
                                tipo={"A"}//status === "L" ? "L" : "A"
                                selectedAll={selectDupAll}
                                handleColumnLiqClick={handleColumnLiqClick}
                                handleSelectItemClick={handleCheckBoxClick}
                                handleUpdateDuplicataList={filterDados}
                            />

                        }

                        {status === 'L' &&

                            <GridContaAPagarEstorno
                                duplicata={ctaPagarEstornoList}
                                handleSelectItemClick={handleCheckBoxEstornoClick}
                            />

                        }

                    </div>

                </div>

                <ModalLiqDup
                    visible={modalLiqDupVisible}
                    totSelecionado={totSelecionado}
                    dupSelectedList={dupSelectedList}
                    handleModalClose={fecharModalLiqDup}
                    handleConfirm={filterDados}
                />

                <ModalEstornaDup
                    visible={modalCancelLiqVisible}
                    totSelecionado={totSelecionado}
                    qtdDupSelecionado={qtdDupSelecionado}
                    dupSelectedList={dupSelectedList}
                    bordero={borderoSelectedList}
                    handleModalClose={fecharModalEstornaDup}
                    handleConfirm={filterDados}
                />

                {modalTutorialVisible &&
                    <ModalTutorial
                        linkVideo='/tutorial_dupPagar.mp4'
                        title='Tutorial sobre duplicatas a pagar'
                        visible={modalTutorialVisible}
                        onCloseClick={() => setModalTutorialVisible(false)}
                    />
                }

            </div>

        </Template>

    )
}